export default "__VITE_ASSET__79342009__"